module.exports = "/_next/static/fonts/ABCSocialCondensed-Medium-d14039663f03a614db517ee70666f3bd.woff2";